module.exports = __webpack_public_path__ + "img/arecharge.c4e6415f.png";